import { apiClient } from '@/api/client'
import type { DownloadJobDetail, DownloadJobListResponse, DownloadJobSummary } from '@/api/types/download-queue'

export async function submitDownloadUrl(url: string): Promise<DownloadJobSummary> {
  const { data } = await apiClient.post<DownloadJobSummary>('/download-queue', { url })
  return data
}

export async function getDownloadJobs(since?: string): Promise<DownloadJobListResponse> {
  const params = since != null ? { since } : undefined
  const { data } = await apiClient.get<DownloadJobListResponse>('/download-queue', { params })
  return data
}

export async function getDownloadJobDetail(jobId: number): Promise<DownloadJobDetail> {
  const { data } = await apiClient.get<DownloadJobDetail>(`/download-queue/${jobId}`)
  return data
}

export async function retryDownloadJob(jobId: number): Promise<void> {
  await apiClient.post(`/download-queue/${jobId}/retry`)
}

export async function deleteDownloadJob(jobId: number): Promise<void> {
  await apiClient.delete(`/download-queue/${jobId}`)
}

export async function bulkRetryDownloadJobs(): Promise<{ retried: number }> {
  const { data } = await apiClient.post<{ retried: number }>('/download-queue/retry-all')
  return data
}

export async function setDownloadJobPriority(jobId: number, priority: number): Promise<void> {
  await apiClient.post(`/download-queue/${jobId}/priority`, { priority })
}
